import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import thunk from "redux-thunk";
import "airbnb-js-shims/target/es2015";
import allReducers from "./reducers";
import App from "./agent/App";
// import * as registerServiceWorker from "./registerServiceWorker";

import "./index.css";
import "./common.css";
require("smoothscroll-polyfill").polyfill();

const store = createStore(allReducers, applyMiddleware(thunk));
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

ReactDOM.render(
  <ToastContainer hideProgressBar newestOnTop style={{ zIndex: "9999" }} />,
  document.getElementById("toastRoot")
);

// registerServiceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js